import { render } from "./Link.vue?vue&type=template&id=31066bc2"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"

import "./Link.vue?vue&type=style&index=0&id=31066bc2&lang=css"
script.render = render

export default script